import { useTranslation } from 'react-i18next';
import { testimonials } from '@/mocks/faqs';

export default function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            {t('section_testimonials')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            {t('section_testimonials_desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg p-6 border border-background-200/70"
            >
              <p className="text-sm text-foreground-700 leading-relaxed mb-5 italic">
                {item.content}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}